import Auth from './Auth';

const DBLoginPage = Auth;

export default DBLoginPage;
